import { UserManager, WebStorageStateStore  } from 'oidc-client-ts';

export const useAccount = () => {
    const userManager = new UserManager({
        authority: process.env.VUE_APP_IDENTITY_AUTHORITY,
        client_id: process.env.VUE_APP_IDENTITY_CLIENT_ID,
        redirect_uri: process.env.VUE_APP_IDENTITY_REDIRECT_URI,
        scope: process.env.VUE_APP_IDENTITY_SCOPE,
        post_logout_redirect_uri: process.env.VUE_APP_IDENTITY_POST_LOGOUT,
        response_type: 'code',
        userStore: new WebStorageStateStore({ store: window.localStorage }),
    });

    return {
        userManager,
    }
}